
































































import Vue from 'vue'
import Component from 'vue-class-component'
import FormInput from '@/components/lib/input/FormInput.vue'
import { CreateEmployeeRequestModel } from '@/services/types'
import { StoreActionTypes } from '@/store/types'

const ICreateCompanyEmployeeModalFromProps = Vue.extend({
    props: {
        disabled: Boolean
    }
})

@Component({
    components: {
        FormInput
    }
})
export default class CreateCompanyEmployeeModalFrom extends ICreateCompanyEmployeeModalFromProps {
    private componentClass = "CreateCompanyEmployeeModalFrom"
    private firstname = ''
    private surname = ''
    private lastname = ''    
    private email = ''
    private password = ''
    private phone = ''

    firstnameChange(text: string) {
        this.firstname = text
    }

    surnameChange(text: string) {
        this.surname = text
    }
    
    lastnameChange(text: string) {
        this.lastname = text
    }    

    emailChange(text: string) {
        this.email = text
    }

    passwordChange(text: string) {
        this.password = text
    }

    phoneChange(text: string) {
        this.phone = text
    }

    get errorMessage(): string {
        return this.$store.getters.getEmployeesErrorMessage
    }

    get showErrorMessage(): boolean {
        return !!this.errorMessage
    }

    handleAlertDismissed() {
        this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_ERROR_MESSAGE_CLEAR);
    }
 
    public getCreateEmployeeRequestModel(): CreateEmployeeRequestModel {
        return {
            firstname: this.firstname,            
            surname: this.surname,
            lastname: this.lastname,
            email: this.email,
            password: this.password,
            phone: this.phone
        }
    } 

}
